module.exports = __webpack_public_path__ + "img/qixi_activity_bottom.7cb9394a.jpg";